import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';

function LettersSuccessModal(props) {

    return (
        <Modal isOpen={props.open} toggle={props.toggle}>
            <ModalHeader>
                Email Successful
            </ModalHeader>
            <ModalBody>
                <div>
                    Emails sent successfully.
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="danr-green" onClick={props.toggle}><span>OK</span></Button>
            </ModalFooter>
        </Modal>
    );
}

export default LettersSuccessModal;